// ** React Imports
import { Fragment, useState } from 'react'

// ** Styles
import '@styles/react/libs/flatpickr/flatpickr.scss'
import '@styles/react/pages/page-account-settings.scss'

import AllGiftCards from './AllGiftCards/AllGiftCards'
import ActiveGiftCards from './ActiveGiftCards/ActiveGiftCards'
import ExpiredGiftCards from './ExpiredGiftCards/ExpiredGiftCards'
import FullyUsedGiftCards from './FullyUsedGiftCards/FullyUsedGiftCards'
import UserTabs from '../../../components/UserPortalComponents/UserTabs/UserTabs'

const GiftCardsTabs = () => {
  const tabs = ["All Gift Cards", "Active", "Expired", 'Fully Used']
  const [activeTab, setActiveTab] = useState(tabs[0])

  const renderTabContent = () => {
    switch (activeTab) {
      case 'All Gift Cards':
        return <AllGiftCards />;
      case 'Active':
        return <ActiveGiftCards />;
      case 'Expired':
        return <ExpiredGiftCards />;
      case 'Fully Used':
        return <FullyUsedGiftCards />;
      default:
        return null;
    }
  };


  return (
    <Fragment>
    <div className='mx-3'>
      <UserTabs tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />

      {renderTabContent()}
    </div>
  </Fragment>
  )
}

export default GiftCardsTabs
